export default __webpack_public_path__ + "static/media/bg-reset-cover.97198989.jpeg";